import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { retrieve, register } from '../services/blockchain';

// RETRIEVE CRYPTOS
export const retrieveCryptos = createAsyncThunk('blockchain/retrieve', async () => {
    const response = await retrieve({});
    response.data = Object.values(response.data).filter((cripto) => cripto.symbol === "USDT" || cripto.symbol === "BTC")
    return { response: response.data, statusCode: response.status };
});

// REGISTER WALLET
export const registerWallet = createAsyncThunk('blockchain/register', async (args, { getState }) => {
    const { blockchain } = getState();
    const response = await register({
        "u": args["u"],
        "id": args["id"],
        "etiqueta_wallet": blockchain.alias.value,
        "bypass":true,
        "requestUser": "AddWallet",
        "red": blockchain.network.value,
        "cripto": blockchain.crypto.value,
        "direccion": blockchain.address.value,
    });
    return { response: response.data, statusCode: response.status };
});

export const blockchainSlice = createSlice({
    name: 'blockchain',
    initialState: {
        networks: [],
        alias: { value: "", error: true },
        crypto: { value: "", error: true },
        network: { value: "", error: true },
        address: { value: "", error: true },
    },
    reducers: {
        setAlias: (state, action) => { state.alias = action.payload },
        setCrypto: (state, action) => {
            state.crypto = action.payload
        },
        setAddress: (state, action) => { state.address = action.payload },
        setNetwork: (state, action) => { state.network = action.payload },
        setNetworks: (state, action) => { state.networks = action.payload },
    },
    extraReducers: builder => builder
        // retrieveCryptos REDUCER
        .addCase(retrieveCryptos.fulfilled, (state, { payload }) => {
            let nets = {};
            const { response, statusCode } = payload;

            if (statusCode === 200) {
                response.forEach(n => { nets = { ...nets, [n.symbol]: n.networkList.map(n => ({ id: n, value: n })) } });
                state.networks = nets;
            }
        })
})

// Action creators are generated for each case reducer function
export const { setCrypto, setNetwork, setAddress, setAlias } = blockchainSlice.actions
export default blockchainSlice.reducer